import {
  RUNE_PAGE_PRESETS,
  listRunePagePresetIds
} from '../../domain/runes/runeCatalog.js';

/**
 * lobbyRuneSelect — populate/bind rune page dropdown (keeps LobbyController slim).
 */
export function populateLobbyRuneSelect(selectEl, selectedId) {
  if (!selectEl) return;
  const ids = listRunePagePresetIds();
  selectEl.innerHTML = ids.map((id) => {
    const page = RUNE_PAGE_PRESETS[id];
    const selected = id === selectedId ? 'selected' : '';
    return `<option value="${id}" ${selected}>${page.name}</option>`;
  }).join('');
}

export function bindLobbyRuneSelect(selectEl, session, onChange) {
  if (!selectEl || !session) return;
  selectEl.addEventListener('change', (e) => {
    if (!session.setRunePage(e.target.value)) {
      e.target.value = session.runePage;
      return;
    }
    if (typeof onChange === 'function') onChange();
  });
}
